import React, { useMemo } from 'react';
import { OrderedListToNumberedList } from './generic/OrderedListToNumberedList';
import { ParseListsFromTextFile } from '../utils/file-parsers';
import { useReadTextFileRaw } from '../utils/file-reader';
import { useParams } from 'react-router';
import { Typography } from '@mui/material';

const GwenGOTYListsText = require('../source-data/GwenGOTYLists.txt');

export const GwenGOTYList = () => {
    const { year = '2025' } = useParams();
    const data = useReadTextFileRaw(GwenGOTYListsText);
    const parsedLists = useMemo(() => ParseListsFromTextFile(data), [data]);
    const selectedYearList = useMemo(() => {
        // GwenGOTYLists.txt is ordered by year, starting at 2023
        const firstYear = 2023;
        return parsedLists[parseInt(year) - firstYear];
    }, [year, parsedLists]);
    return (
        <div>
            <Typography variant="body2">Games Gwen played in {year} in ranked order</Typography>
            <OrderedListToNumberedList data={selectedYearList} filterReplays={false} note={null} />
        </div>
    );
};
